<template>
  <div class="row flexSpace" v-if="$store.state.webNavigator=='pc'">
    <div :style="{width: 63*(100/960)+'vw',height: 25*(100/960)+'vw',borderRadius: 50+'%',cursor:'pointer'}" @click="blackHomePage">
      <img :src="src" title="脂玫乐健康瘦身网" alt="脂玫乐" :style="{width: 63*(100/960)+'vw',height: 25*(100/960)+'vw',borderRadius: 50+'%'}"/>
    </div>
    <div class="locate-keyword firstText">
      健康瘦身 发现更好的自己
    </div>
    <div class="phone-number firstText" :style="{whiteSpace: 'nowrap',display: 'inline-block',fontSize: 11*(100/960)+'vm',fontFamily: 'MicrosoftYaHei',fontWeight: 'bold',color: '#00CDA2'}">400-8855-091</div>
    <div style="flex:1;display: flex;justify-content: flex-end;">
      <ul class="list-ul flexStart">
        <!-- 一级导航 -->
        <li class="list-li pointEr" :style="{position: 'relative',display: 'inline-block',marginRight: 10*(100/960)+'vw',fontSize: 8*(100/960)+'vw',lineHeight: 20*(100/960)+'vw',fontFamily: 'MicrosoftYaHei',fontWeight: 400,color: '#999'}" v-for="(item , index) in bararr" :key="index" @click="path(item,index)">
          <div class="top-a" :class="{'Active':TopAct==index+1} ">
            <!-- 减肥知识 -->
            <div class="list-div" v-if="index==3">
              <div class="list-top" v-if="index1==0" v-for="(item1 , index1) in toplist" :key="index1" style="">
                <ul>
                  <li @click.stop="gotoPath(item2,index)" v-for="(item2 , index) in item1.data"
                      :key="index" :style="{whiteSpace: 'nowrap',fontSize:8*(100/960)+'vw',fontFamily:'MicrosoftYaHei',fontWeight:400,color:'#000000',lineHeight:14*(100/960)+'vw',display: 'block'}">{{item2.text}}
                  </li>
                </ul>
              </div>
            </div>
            <!-- 减肥案例 -->
            <div class="list-div" v-if="index==1">
              <div class="list-top" style="">
                <ul>
                  <div @click="path(item1)" class="change-color" v-for="(item1 , index1) in item.jfallist"
                       :key="index1">{{item1.name}}
                  </div>
                </ul>
              </div>
            </div>
            <div class="firstName">{{item.name}}</div>
          </div>
        </li>
      </ul>
    </div>
  </div>
  <div v-else>
    <div class="big-box row flexSpace" v-if="TopAct == '6'||TopAct == '0'||TopAct == '2'" :style="{position: 'fixed',top: 0,left: 0,right: 0,zIndex: 99,height: 110*(100/750)+'vw',
  backgroundSize: 'cover',paddingLeft:30*(100/750)+'vw',paddingRight:30*(100/750)+'vw'}">
      <div>
        <img :style="{width: 148*(100/960)+'vw',height: 58*(100/960)+'vw',marginRight: 28*(100/960)+'vw',cursor:'pointer'}" title="脂玫乐健康瘦身网" :src="src1"
             alt="脂玫乐" @click="blackHomePage"/>
        <div class="displayIB colffffff">
          <p class="font16phone">健康瘦身 发现更好的自己</p>
          <p class="font25phone fontWeightB">400-8855-091</p>
        </div>
      </div>
      <div @click="downloadApp" :style="{width: 84*(100/750)+'vw',height: 34*(100/750)+'vw'}" class="positionID">
          <img :src="src2" alt="" title="" style="width:100%;height:100%">
      </div>
      <div @click="showMainNav" :style="{width: 41*(100/750)+'vw',height: 34*(100/750)+'vw'}">
        <img alt="" title="" :class="this.$store.state.mainNavShowStatus?'more-icon2':'more-icon'"
             :src="this.$store.state.mainNavShowStatus?src3:src4"/>
      </div>
    </div>
    <div class="big-box2 row flexSpace" v-else :style="{position: 'fixed',top: 0,left: 0,right: 0,zIndex: 99,height: 110*(100/750)+'vw',
  backgroundSize: 'cover',paddingLeft:30*(100/750)+'vw',paddingRight:30*(100/750)+'vw'}">
      <div>
        <img :style="{width: 148*(100/960)+'vw',height: 58*(100/960)+'vw',marginRight: 28*(100/960)+'vw',cursor:'pointer'}" title="脂玫乐健康瘦身网" :src="src5"
             alt="脂玫乐" @click="blackHomePage"/>
        <div class="displayIB col666666">
          <p class="font16phone">健康瘦身 发现更好的自己</p>
          <p class="font25phone fontWeightB col00CDA2">400-8855-091</p>
        </div>
      </div>
      <div :style="{width: 84*(100/750)+'vw',height: 34*(100/750)+'vw'}" @click="downloadApp" class="positionID">
          <img :src="src6" alt="" title="" style="width:100%;height:100%">
      </div>
      <div @click="showMainNav" :style="{width: 41*(100/750)+'vw',height: 34*(100/750)+'vw'}">
        <img alt="" title="" :class="this.$store.state.mainNavShowStatus?'more-icon2':'more-icon'"
             :src="this.$store.state.mainNavShowStatus?src7:src8"/>
      </div>
    </div>
  </div>
</template>
<script>
import { myFun}  from '../../plug/modifyImagePath'
import {$get, } from '../../others/ajax';
import config from '@/others/interface';
// import pinyinUtil from
export default {
  name: 'TopNavigation',
  props: {
    TopAct: {
      type: String,
      default: '1',
    },
  },
  data () {
    return {
      toplist: [],
      jfallist: '',
      navbtntype: true,
      bararr: [
        {
          name: '首页',
          hrefs: '/',
        },
        // {
        //   name: '减肥案例',
        //   // hrefs: '/caseVideo/0/1/anlishipin.html',
        //   hrefs: '/caseVideo/0-1-anlishipin.html',
        //   jfallist: [
        //     {
        //       name: '案例视频',
        //       hrefs: '/caseVideo/0-1-anlishipin.html',
        //     },
        //     {
        //       name: '案例分享',
        //       hrefs: '/caseSharing/1-1-anlifenxiang.html',
        //     },
        //   ],
        // },
        {
          name: '关于产品',
          hrefs: '/aboutProducts/guanyuchanpin.html',
        },
        {
          name: '减肥视频',
          hrefs: '',
        },
        {
          name: '减肥知识',
          hrefs: '',
        },
        {
          name: '品牌资讯',
          hrefs: '/brandInfo/A5-0-1-pingpaizixun.html',
        },
        {
          name: '防伪查询',
          hrefs: '/search/fangweichaxun.html',
        },
        {
          name: '脂玫乐APP',
          hrefs: '/zmlapp/zmlAPP.html',
        },
        {
          name: '联系我们',
          hrefs: '/about/lianxiwomen.html',
        },
      ],
      src: myFun("https://jusewebapp.oss-cn-hangzhou.aliyuncs.com/zml-gw/logo.png"),
      src1: myFun("https://jusewebapp.oss-cn-hangzhou.aliyuncs.com/zml-gw/v1.1.1/phone/logo.png"),
      src2: myFun("https://jusewebapp.oss-cn-hangzhou.aliyuncs.com/zml-gw/%E7%BB%84%2025.png"),
      src3: myFun('https://jusewebapp.oss-cn-hangzhou.aliyuncs.com/zml-gw/v1.1.1/phone/navbtn2.png'),
      src4: myFun('https://jusewebapp.oss-cn-hangzhou.aliyuncs.com/zml-gw/v1.1.1/phone/navbut.png'),
      src5: myFun("https://jusewebapp.oss-cn-hangzhou.aliyuncs.com/zml-gw/v1.1.1/phone/actlogo.png"),
      src6: myFun("https://jusewebapp.oss-cn-hangzhou.aliyuncs.com/zml-gw/%E6%89%93%E5%BC%80APP%402x.png"),
      src7: myFun('https://jusewebapp.oss-cn-hangzhou.aliyuncs.com/zml-gw/v1.1.1/phone/actbtn2.png'),
      src8: myFun('https://jusewebapp.oss-cn-hangzhou.aliyuncs.com/zml-gw/v1.1.1/phone/actbtn.png')
    };
  },
  methods: {
    downloadApp(){
      window.open('https://spread.gooeto120.top/zml/pinpai',"_blank")
    },
    showMainNav () {
      this.navbtntype = !this.navbtntype;
      this.$store.commit('changeMainNavShowStatus');
    },
    getTopList () {
      $get(config.zmlgw + '/web/getEndClass', {}).then((res) => {
        if (res.code == 200) {
          this.toplist = res.returnData;
        }
      });
    },
    path (item, index) {
      let helpcode = pinyinUtil.getPinyin(this.toplist[1].data[0].text, '', false, false);
      let helpcode2 = pinyinUtil.getPinyin(this.toplist[0].data[0].text, '', false, false);
      if (index == 2) {
        this.$router.push({path: '/encyclopeDias/' + this.toplist[1].data[0].id + '-0-1-' + helpcode + '.html', });
        // this.closeNav();
      } else if (index == 3) {
        this.$router.push({path: '/InformationList/' + this.toplist[0].data[0].id + '-0-1-' + helpcode2 + '.html', });
        // this.closeNav();
      } else {
        this.$router.push({path: item.hrefs, });
      }
    },
    gotoPath (item, index) {
      sessionStorage.setItem('pageText', item.text);
      let helpcode = pinyinUtil.getPinyin(item.text, '', false, false);
      this.$router.push({path: '/InformationList/' + item.id + '-' + index + '-1-' + helpcode + '.html', });
    },
    blackHomePage(){
      window.location.href = 'https://www.zmelo.com/';
    }
    // gotoPath2 (item) {
    //   this.$router.push({path: '/encyclopeDias/' + item.id + '/1/' + item.text + '.html', });
    // },
  },
  created () {
    this.getTopList();
  },
};
</script>

<style lang="less" scoped>
  @media screen and (max-width: 800px) {
    @import url("./TopNavigationPhone.less");
  }

  @media screen and (min-width: 801px) {
    @import url("./TopNavigation.less");
  }
</style>



// WEBPACK FOOTER //
// TopNavigation.vue